export default __webpack_public_path__ + "static/media/two.7a72afed.jpeg";